// extracted by mini-css-extract-plugin
export default {"card":"B6-z"};